import request from '../../../helpers/request';
import { createFormDataFile } from '../utils/createFormDataFile';

const addAttachmentToHouse = async (houseId, file, data) => {
  const formData = new FormData();

  const validFile = createFormDataFile(file.originFileObj);

  const validData = JSON.stringify(data);

  formData.append('file', validFile);
  formData.append('data', validData);

  return await request.post(
    `/HousingStock/house/${houseId}/attachment`,
    formData,
    'При загрузке документа произошла ошибка'
  );
};

export default addAttachmentToHouse;
